import { AuthGlobal } from "../types/auth";

export const getMasterVendorName = (authState?: Partial<AuthGlobal> | null): string => {
  const fromState = authState?.masterVendorName;
  const fromCurrentUser =
    authState?.currentUser?.master_vendor_name ?? authState?.currentUser?.masterVendorName ?? "";

  return String(fromState || fromCurrentUser || "").trim();
};

export const isAvanseMasterVendor = (authState?: Partial<AuthGlobal> | null): boolean =>
  getMasterVendorName(authState).toLowerCase() === "avanse";

export const getRemitterContactDetails = (remitter: any) => ({
  email: remitter?.email ?? "",
  mobile: remitter?.phoneNumber ?? remitter?.mobile ?? remitter?.mobileNumber ?? "",
});

export const getSearchQuoteDetailsRequest = (
  authState: Partial<AuthGlobal> | null | undefined,
  remitter: any,
  amountCalculation?: any
) => {
  if (!isAvanseMasterVendor(authState) || !remitter?.userKey) return null;

  const { email, mobile } = getRemitterContactDetails(remitter);

  return {
    email,
    mobile,
    transaction_purpose: amountCalculation?.transaction_purpose ?? "",
    dest_currency: amountCalculation?.dest_currency ?? "",
  };
};

export const formatQuoteDateTime = (value?: string | null) => {
  if (!value) return "—";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatQuoteMoney = (currency?: string | null, amount?: number | null) => {
  if (amount === null || amount === undefined) return "—";

  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  if (currency) return `${formatted} ${currency}`;
  return formatted;
};

export const getLoginMasterVendorName = (loginData: any): string =>
  String(loginData?.master_vendor_name ?? loginData?.masterVendorName ?? "").trim();

export const isRemitterProfileIncomplete = (remitter: any): boolean => {
  if (!remitter) return true;

  const fields = [
    remitter.gender,
    remitter.nationality,
    remitter.employmentStatus,
    remitter.industryType,
  ];

  return fields.some((value) => value === null || value === undefined || value === "");
};

export const canProceedToAvanseQuoteFlow = (remitter: any): boolean =>
  Boolean(remitter?.isDocVerified) && !isRemitterProfileIncomplete(remitter);
